<template>
  <v-container fluid>
    <!--LoadingMask :loading="loading" /-->
    <ConfirmDeleteDialog :item="itemToRemove"
      title="Remove transaction" @confirm-delete="remove" ref="confirmDialog"/>
    <v-card v-if="selectedItems.length > 0">
      <v-card-title>Bulk operations</v-card-title>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="6" xs="12">
            <v-select dense label="Category"
              v-model="category" :items="fields[2].items"
              outlined>
            </v-select>
          </v-col>
          <v-col cols="6" xs="12">
            <v-btn small rounded @click.stop="setSelectionCategory()" class="ma-2" :disabled="!category || loading">
              Set Category
            </v-btn>
            <v-btn small rounded @click.stop="cancelSelectionsCategory()" class="ma-2">
              Cancel
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" xs="12">
            <v-radio-group dense v-model="gstIncluded" outlined row>
              <v-spacer></v-spacer>
              <v-label>GST Included</v-label>
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" xs="12">
            <v-btn small rounded @click.stop="setSelectionGST()" class="ma-2 mt-4" :disabled="gstIncluded === null || loading">
              Set
            </v-btn>
            <v-btn small rounded @click.stop="cancelSelectionsGST()" class="ma-2 mt-4">
              Cancel
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn rounded @click.stop="clearSelections()" class="ma-2">
              Unselect
            </v-btn>
            <v-btn color="error" rounded @click.stop="confirmRemove()" class="ma-2" :disabled="loading">
              Delete selections
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-list tow-line class="transaction-list">
      <v-list-item v-for="(item, idx) in items" :key="item.id"
        v-observe-visibility="idx === items.length - 1 && nextPageUrl !== null ? loadMore : false"
        @click="$emit('load-detail', item)" :class="'row-' + (idx % 2 === 0 ? 'even' : 'odd')">
        <v-list-item-content>
          <v-list-item-title>
            <v-icon v-if="item.trans_source === 'B'">upload</v-icon>
            <v-icon v-else>edit</v-icon>
            {{ item.description }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-container style="padding:12px 0 0 0">
              <v-row no-gutters v-if="compact || $vuetify.breakpoint.smAndDown">
                <v-col cols="5">{{ item.transtime }}</v-col>
                <v-col cols="6">{{ item.category_obj.name }}</v-col>
                <v-col cols="1" class="text-right">
                  <v-btn large @click.stop="confirmRemove(item)" icon
                    color="red lighten-3" style="margin-top:-12px"
                    :disabled="loading"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="5">
                  <span :class="amountColor(item)">
                    <span>${{ item.amount }}</span>
                  </span>
                  <span v-if="item.gst !== null">
                    <span class="blue--text text--darken-2 font-weight-bold" style="font-size:11px">
                      GST <span>${{ item.gst }}</span>
                    </span>
                  </span>
                </v-col>
                <v-col cols="7">{{ item.bank_account_obj.name }}</v-col>
              </v-row>
              <v-row no-gutters v-else>
                <v-col cols="2">{{ item.transtime }}</v-col>
                <v-col cols="3">{{ item.category_obj.name }}</v-col>
                <v-col cols="3">{{ item.bank_account_obj.name }}</v-col>
                <v-col cols="3">
                  <span :class="amountColor(item)">
                    <span>${{ item.amount }}</span>
                  </span>
                  <span v-if="item.gst !== null">
                    <span class="blue--text text--darken-2 font-weight-bold" style="font-size:11px">
                      GST <span>${{ item.gst }}</span>
                    </span>
                  </span>
                </v-col>
                <v-col cols="1" class="text-right">
                  <v-btn large @click.stop="toggleSelection(item.id)"
                    icon color="primary lighten-1" style="margin-top:-12px"
                    :disabled="loading"
                  >
                    <v-icon v-if="selectedItems.indexOf(item.id) >= 0">check_box</v-icon>
                    <v-icon v-else>check_box_outline_blank</v-icon>
                  </v-btn>
                  <v-btn large @click.stop="confirmRemove(item)"
                    icon color="red lighten-3" style="margin-top:-12px"
                    :disabled="loading"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    </v-list>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ConfirmDeleteDialog from '@/components/dialog/ConfirmDeleteDialog'
import LoadingMask from '@/components/LoadingMask'
import TransactionService from '@/services/TransactionService'

const SubModule = namespace('transaction')

@Component({
  components: {
    ConfirmDeleteDialog,
    LoadingMask
  }
})
export default class TransactionList extends Vue {
  @SubModule.Getter service
  @SubModule.Getter fields

  loading = false
  page = 1
  nextPageUrl = null
  itemToRemove = null
  entityId = null
  bankAccount = null
  filters = null
  compact = false
  items = []
  selectedItems = []
  category = null
  gstIncluded = null

  amountColor (item) {
    return item.trans_type === 'D' ? 'green--text' : 'orange--text'
  }

  setSelectionCategory () {
    if (this.category) {
      let errors = []
      this.loading = true
      this.selectedItems.map(itemId => {
        let item = this.items.find((x) => x.id === itemId)
        TransactionService.partial_update(
          itemId, {
            trans_type: item.trans_type,
            category: this.category
          })
          .then(resp => {
            errors.push({ id: itemId, 'detail': 'OK' })
          })
          .catch(err => {
            errors.push({ id: itemId, 'detail': err })
          })
          .finally(() => {
            this.checkCategoryResult(errors)
          })
      })
    }
  }

  checkCategoryResult (errors) {
    if (errors.length === this.selectedItems.length) {
      errors = errors.filter(item => item.detail !== 'OK')
      if (errors.length === 0) {
        this.$emit('show-message', {
          message: 'Saved successfully.'
        })
      } else {
        this.$emit('show-message', {
          message: `Failed to save ${errors.length} transaction(s)`,
          error: errors
        })
      }
      this.cancelSelectionsCategory()
      this.load(this.entityId, this.bankAccount, this.filters)
    }
  }

  cancelSelectionsCategory () {
    this.category = null
  }

  setSelectionGST () {
    if (this.gstIncluded !== null) {
      let errors = []
      this.loading = true
      this.selectedItems.map(itemId => {
        let item = this.items.find((x) => x.id === itemId)
        TransactionService.partial_update(
          itemId, {
            trans_type: item.trans_type,
            gst_included: this.gstIncluded
          })
          .then(resp => {
            errors.push({ id: itemId, 'detail': 'OK' })
          })
          .catch(err => {
            errors.push({ id: itemId, 'detail': err })
          })
          .finally(() => {
            this.checkGSTResult(errors)
          })
      })
    }
  }

  checkGSTResult (errors) {
    if (errors.length === this.selectedItems.length) {
      errors = errors.filter(item => item.detail !== 'OK')
      if (errors.length === 0) {
        this.$emit('show-message', {
          message: 'Saved successfully.'
        })
      } else {
        this.$emit('show-message', {
          message: `Failed to save ${errors.length} transaction(s)`,
          error: errors
        })
      }
      this.cancelSelectionsGST()
      this.load(this.entityId, this.bankAccount, this.filters)
    }
  }

  cancelSelectionsGST () {
    this.gstIncluded = null
  }

  clearSelections () {
    this.cancelSelectionsCategory()
    this.cancelSelectionsGST()
    this.selectedItems.splice(0)
  }

  toggleSelection (itemId) {
    const idx = this.selectedItems.indexOf(itemId)
    if (idx === -1) {
      this.selectedItems.push(itemId)
    } else {
      this.selectedItems.splice(idx, 1)
    }
  }

  loadMore (isVisible, entry) {
    if (isVisible) {
      this.page += 1
      this.load(this.entityId, this.bankAccount, this.filters, true)
    }
  }

  load (entityId, bankAccount, filters, append = false) {
    let params = {}
    this.entityId = entityId
    if (bankAccount !== 0) {
      this.bankAccount = bankAccount
      params.bank_account = bankAccount
    }
    if (filters) {
      this.filters = filters
      params = { ...params, ...filters }
    }
    if (!append) {
      this.page = 1
      this.items = []
    }
    this.loading = true
    this.service.list(this.entityId, params, this.page)
      .then(resp => {
        if (append) {
          this.items = this.items.concat(resp.data.results || resp.data)
        } else {
          this.items = resp.data.results || resp.data
        }
        this.nextPageUrl = resp.data.next
      })
      .catch(err => {
        this.nextPageUrl = null
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  setCompact (compact) {
    this.compact = compact
  }

  editItem (item) {
    const idx = this.cashbooks.indexOf(item)
    this.$refs.dialog.editItem(item, idx)
  }

  confirmRemove (item = null) {
    if (item === null) {
      this.itemToRemove = this.selectedItems
      this.itemToRemove.name = `${this.selectedItems.length} selected transactions`
    } else {
      this.itemToRemove = item
      this.itemToRemove.name = item.description
    }
    this.$refs.confirmDialog.open()
  }

  remove () {
    const itemsToRemove = Array.isArray(this.itemToRemove) ? this.itemToRemove : [this.itemToRemove.id]
    let errors = []
    this.loading = true
    itemsToRemove.map(itemId => {
      this.service.delete(itemId)
        .then(resp => {
          errors.push({ id: itemId, 'detail': 'OK' })
        })
        .catch(err => {
          errors.push({ id: itemId, 'detail': err })
        })
        .finally(() => {
          this.checkDeleteResult(itemsToRemove, errors)
        })
    })
    this.itemToRemove = null
    this.$refs.confirmDialog.close()
  }

  checkDeleteResult (items, errors) {
    if (errors.length === items.length) {
      errors = errors.filter(item => item.detail !== 'OK')
      if (errors.length === 0) {
        this.$emit('show-message', {
          message: 'Deleted successfully.'
        })
      } else {
        this.$emit('show-message', {
          message: `Failed to delete ${errors.length} transaction(s)`,
          error: errors
        })
      }
      this.load(this.entityId, this.bankAccount, this.filters)
      this.$emit('load-balance')
      this.clearSelections()
    }
  }

  open (idx) {
    this.$refs.dialog.open()
  }

  save (data) {
    const idx = data.idx
    if (idx > -1) {
      Object.assign(this.cashbooks[idx], data.item)
    } else {
      this.cashbooks.push(data.item)
    }
  }

  getCodeColor (code) {
    if (code >= 11 && code < 20) {
      return 'blue'
    }
    if (code >= 20 && code <= 30) {
      return 'green'
    }
    if (code > 30) {
      return 'purple'
    }
    return 'black'
  }

  getCodeText (code) {
    if (code >= 11 && code < 20) {
      return 'D'
    }
    if (code >= 20 && code <= 30) {
      return 'G'
    }
    if (code > 30) {
      return 'W'
    }
    return ' '
  }
}
</script>

<style lang="scss">
.transaction-list {
  border-top: 1px solid rgba(0,0,128,.2) !important;
  .v-list-item__content {
    padding: 8px 0 0 0;
  }
  .row-even {
    border-bottom: 1px solid rgb(0, 0, 128, .2);
    background-color: rgba(0, 60, 128, .1);
  }
  .row-odd {
    border-bottom: 1px solid rgb(0, 0, 128, .2);
    background-color: white;
  }
}
.list-mask {
  position: fixed;
  left: 0; right: 50%;
  top: 64px; bottom: 60px;
  z-index:10;
  background-color: black;
  opacity: 0.25;
}
</style>
